module.exports = __webpack_public_path__ + "img/2.02959bb0.jpg";